import { render, staticRenderFns } from "./ventes.html?vue&type=template&id=417cd019&scoped=true&external"
import script from "./ventes.js?vue&type=script&lang=js&external"
export * from "./ventes.js?vue&type=script&lang=js&external"
import style0 from "./ventes.scss?vue&type=style&index=0&id=417cd019&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417cd019",
  null
  
)

export default component.exports